import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormCloudEnvironmentResponse } from '~/models/Comons';
import { RootState } from '~/store/index';

interface State {
    cloudEnviroment: FormCloudEnvironmentResponse[];
     authenticated: boolean;
}

const initialState: State = {
    cloudEnviroment: [],
    authenticated:false
};

const CloudEnviromentSlice = createSlice({
    name: 'cloudEnviroment',
    initialState,
    reducers: {
        SET_CLOUDENVIROMENT(state, { payload }: PayloadAction<FormCloudEnvironmentResponse[]>) {
            state.cloudEnviroment = payload;
        },
            DELETE_CLOUDENVIROMENT_BYID(state, { payload }: PayloadAction<number>) {
            if (!Array.isArray(state.cloudEnviroment)) {
                state.cloudEnviroment = []; // Ensure it's an array
            }

            state.cloudEnviroment = state.cloudEnviroment.map(item =>
                item.id !== payload ? item : { ...item, active: false }
            );
        },

        ADD_CLOUDENVIROMENT(state, { payload }: PayloadAction<FormCloudEnvironmentResponse>) {
            const newScripts = [...state.cloudEnviroment, payload];
            state.cloudEnviroment = newScripts;
        },
        PATCH_CLOUDENVIROMENT(state, { payload }: PayloadAction<FormCloudEnvironmentResponse>) {
            const newCloudEnviroment = [...state.cloudEnviroment];
            const findInd = newCloudEnviroment.findIndex(({ id }) => id === payload.id);
            if (findInd < 0) return;

            newCloudEnviroment[findInd] = { ...payload };
            state.cloudEnviroment = newCloudEnviroment;
        },
         SET_AUTHENTICATED(state, { payload }: PayloadAction<boolean>) {
            state.authenticated = payload;
        },
    },
});

export const selectCLoudEnviroment = (state: RootState) => state.script;

export const { SET_CLOUDENVIROMENT, DELETE_CLOUDENVIROMENT_BYID, ADD_CLOUDENVIROMENT, PATCH_CLOUDENVIROMENT,SET_AUTHENTICATED } =
    CloudEnviromentSlice.actions;

export default CloudEnviromentSlice.reducer;
